<template>
  <v-app style="background-color: #f8f9fb">
    <v-dialog v-model="loading" persistent max-width="300">
      <v-card>
        <v-card-title> Salvando arquivo... </v-card-title>
        <v-card-text>
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="permissoesDialog" max-width="1000px" persistent>
      <v-card>
        <v-card-title class="headline primary white--text text-center py-4">
          Acesso ao Arquivo
        </v-card-title>

        <v-card-text class="pt-4" style="min-height: 200px">
          <v-select
            v-model="tipoPermissao"
            :items="['Grupo', 'Usuário']"
            label="Tipo de permissão"
            outlined
            dense
            hide-details
          ></v-select>

          <!-- Tabela de grupos -->
          <div v-if="tipoPermissao === 'Grupo'" class="mt-2">
            <v-row>
              <v-col cols="6" md="6"></v-col>
              <v-col cols="6" md="6" class="d-flex justify-end py-0"
                ><v-text-field
                  v-model="search"
                  label="Buscar..."
                  append-icon="mdi-magnify"
                  dense
                  hide-details
                  outlined
                  class="my-4"
                ></v-text-field
              ></v-col>
              <v-col cols="12" md="12" class="px-0 py-0"
                ><v-data-table
                  height="40vh"
                  :headers="headersGrupos"
                  :items="listaGrupos"
                  :search="search"
                  item-key="grupo.id"
                  show-select
                  item-per-page="10"
                  v-model="gruposSelecionados"
                  dense
                  class="elevation-0"
                >
                  <template v-slot:item.colaboradores="{ item }">
                    {{ item.colaboradores.length }}
                  </template>
                </v-data-table></v-col
              >
            </v-row>
          </div>

          <!-- Tabela de usuários/colaboradores -->
          <div v-else-if="tipoPermissao === 'Usuário'" class="mt-2">
            <v-row>
              <v-col cols="6" md="6"></v-col>
              <v-col cols="6" md="6" class="d-flex justify-end py-0"
                ><v-text-field
                  v-model="search"
                  label="Buscar..."
                  append-icon="mdi-magnify"
                  dense
                  hide-details
                  outlined
                  class="my-4"
                ></v-text-field
              ></v-col>
              <v-col cols="12" md="12" class="px-0 py-0">
                <v-data-table
                  height="40vh"
                  fixed-header
                  :headers="headersColaboradores"
                  :items="listaColaboradores"
                  :search="search"
                  item-key="id"
                  show-select
                  :items-per-page="10"
                  v-model="colaboradoresSelecionados"
                  dense
                  class="elevation-0"
                ></v-data-table
              ></v-col>
            </v-row>
          </div>
          <div v-else class="text-center py-8">
            <v-icon size="64" color="grey lighten-1">mdi-account-group</v-icon>
            <div class="grey--text mt-4">
              Selecione um tipo para visualizar os colaboradores
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="
              permissoesDialog = false;
              tipoPermissao = '';
              search = '';
            "
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="newDoc" persistent max-width="400px">
      <v-card>
        <v-card-title class="headline primary white--text text-center py-4">
          Adicionar novo documento
        </v-card-title>

        <v-card-text class="pt-4">
          Ao adicionar um novo documento, o sistema manterá as informações de
          categorização e você poderá editar os dados específicos. Todos os
          documentos serão enviados juntos ao salvar.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="newDoc = false">
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            @click="
              vincularDocumento();
              newDoc = false;
            "
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Erro -->
    <v-dialog v-model="erroDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline error white--text text-center py-4">
          <v-icon color="white" class="mr-2">mdi-alert-circle</v-icon>
          Erro ao Salvar Documento
        </v-card-title>
        <v-card-text class="pt-6">
          <v-alert type="error" outlined dense>
            {{ mensagemErro }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="erroDialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container style="background-color: #eee" fluid tag="section">
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-file-plus"
            title="Cadastro de Arquivo"
            color="green"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-4"
          >
            <v-container>
              <div class="d-flex mb-6">
                <v-btn
                  color="primary"
                  text
                  @click="voltar"
                  :disabled="loading"
                  class="text-capitalize font-weight-medium"
                >
                  <v-icon left size="20">mdi-arrow-left</v-icon>
                  Voltar
                </v-btn>
              </div>

              <v-alert
                v-if="idOrigem"
                type="info"
                dense
                outlined
                class="mb-4"
                border="left"
              >
                Enviando arquivo vinculado ao ID de origem:
                <strong>{{ idOrigem }}</strong>
              </v-alert>

              <v-form ref="form" v-model="valid">
                <!-- Categorização -->
                <v-card class="mb-6 card-section" outlined elevation="0">
                  <v-card-title class="section-header">
                    <v-icon color="orange" class="mr-2">mdi-tag-outline</v-icon>
                    <span class="subtitle-1 font-weight-bold"
                      >Categorização</span
                    >
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="pt-6">
                    <v-row>
                      <v-col cols="12" md="6" class="pb-0">
                        <v-select
                          v-model="documento.empresa"
                          :items="filteredEmpresas"
                          label="Empresa"
                          :rules="[rules.required]"
                          outlined
                          dense
                          required
                          prepend-inner-icon="mdi-domain"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6" class="pb-0">
                        <v-select
                          v-model="documento.departamento"
                          :items="departamentos"
                          label="Departamento"
                          :rules="[rules.required]"
                          @change="$refs.fileInput.validate()"
                          outlined
                          dense
                          prepend-inner-icon="mdi-office-building"
                        ></v-select>
                      </v-col>

                      <v-col cols="12" md="6" class="pb-0">
                        <v-select
                          v-model="documento.categoria"
                          :items="categoriasDisponiveis"
                          label="Categoria"
                          :rules="[rules.required]"
                          outlined
                          dense
                          required
                          prepend-inner-icon="mdi-bookmark-outline"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6" class="pb-0">
                        <v-select
                          v-model="documento.subCategoria"
                          :items="subcategoriasDisponiveis"
                          label="Subcategoria"
                          outlined
                          :rules="[rules.required]"
                          dense
                          :disabled="!documento.categoria"
                          prepend-inner-icon="mdi-bookmark-multiple-outline"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Informações Básicas -->
                <v-card
                  class="mb-6 card-section"
                  outlined
                  elevation="0"
                  id="informacoes_basicas"
                >
                  <v-card-title class="section-header">
                    <v-icon color="blue" class="mr-2"
                      >mdi-information-outline</v-icon
                    >
                    <span class="subtitle-1 font-weight-bold"
                      >Informações Básicas</span
                    >
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="pt-6">
                    <v-row>
                      <v-col cols="12" md="6" class="pb-0">
                        <v-text-field
                          v-model="documento.titulo"
                          label="Título do Documento"
                          placeholder="Ex: Contrato de Prestação de Serviços"
                          :rules="[rules.required]"
                          maxlength="50"
                          counter
                          outlined
                          dense
                          required
                          prepend-inner-icon="mdi-file-document-outline"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="pb-0">
                        <v-text-field
                          v-model="documento.identificacao"
                          :label="consultarLabelCampoChave"
                          outlined
                          dense
                          :disabled="documento.categoria === ''"
                          prepend-inner-icon="mdi-file-outline"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="pb-0">
                        <v-textarea
                          v-model="documento.descricao"
                          label="Descrição"
                          placeholder="Descreva brevemente o conteúdo do documento..."
                          outlined
                          dense
                          rows="3"
                          prepend-inner-icon="mdi-text"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Controle de Versão e Datas -->
                <v-card class="mb-6 card-section" outlined elevation="0">
                  <v-card-title class="section-header">
                    <v-icon color="purple" class="mr-2"
                      >mdi-clock-outline</v-icon
                    >
                    <span class="subtitle-1 font-weight-bold"
                      >Controle de Versão e Datas</span
                    >
                    <v-switch
                      v-model="showDatas"
                      :label="
                        showDatas
                          ? 'Desativar Controle de Datas'
                          : 'Ativar Controle de Datas'
                      "
                      hide-details
                      class="mt-0 ml-4"
                    ></v-switch>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="pt-6">
                    <v-row v-if="showDatas">
                      <v-col cols="12" md="3" class="pb-0">
                        <v-menu
                          v-model="dataValidadeMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="dataValidadeFormatted"
                              label="Data de Validade"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              dense
                              prepend-inner-icon="mdi-calendar"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="documento.dataValidade"
                            no-title
                            @input="dataValidadeMenu = false"
                            locale="pt-BR"
                            color="green"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="3" class="pb-0">
                        <v-menu
                          v-model="dataVencimentoMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="dataVencimentoFormatted"
                              label="Data de Vencimento"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              dense
                              prepend-inner-icon="mdi-calendar-alert"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="documento.dataVencimento"
                            no-title
                            @input="dataVencimentoMenu = false"
                            locale="pt-BR"
                            color="green"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Anexar Arquivos -->
                <v-card class="mb-6 card-section" outlined elevation="0">
                  <v-card-title class="section-header">
                    <v-icon color="green" class="mr-2">mdi-paperclip</v-icon>
                    <span class="subtitle-1 font-weight-bold"
                      >Anexar Arquivos</span
                    >
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="pt-6">
                    <v-row>
                      <v-col cols="12" class="pb-0">
                        <v-file-input
                          v-model="arquivo"
                          label="Selecione um arquivo"
                          prepend-icon="mdi-cloud-upload-outline"
                          outlined
                          :rules="[rules.fileSizeByDepartamento]"
                          show-size
                          :accept="'.pdf,.png,.jpg,.jpeg,.docx,.xls,.xlsx'"
                          counter
                          clearable
                          multiple
                          ref="fileInput"
                        >
                          <template v-slot:selection="{ text }">
                            <v-chip
                              small
                              label
                              color="green"
                              text-color="white"
                            >
                              <v-icon left small>mdi-file</v-icon>
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                        <!-- Preview Expansion Panel -->
                        <v-expansion-panels
                          v-if="arquivo"
                          class="mb-4"
                          flat
                          :value="-1"
                        >
                          <v-expansion-panel class="expansion-panel">
                            <v-expansion-panel-header>
                              <div class="d-flex align-center">
                                <v-icon left color="primary"
                                  >mdi-eye-outline</v-icon
                                >
                                <span class="font-weight-medium"
                                  >Previsualização</span
                                >
                              </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content >
                              <v-row >
                                <v-col
                                  v-for="(file, index) in arquivosSelecionados"
                                  :key="index"
                                  :cols="
                                    arquivosSelecionados.length === 1 ? 12 : 12
                                  "
                                  :md="
                                    arquivosSelecionados.length === 1 ? 12 : 6
                                  "
                                  
                                >
                                  <v-card outlined class="pa-2 mt-4">
                                    <!-- HEADER -->
                                    <div
                                      class="d-flex justify-space-between align-center mb-2"
                                    >
                                      <div
                                        class="text-subtitle-2 font-weight-medium text-truncate"
                                      >
                                        {{ file.name }}
                                      </div>

                                      <v-chip x-small color="grey lighten-2">
                                        {{ formatSize(file.size) }}
                                      </v-chip>
                                    </div>

                                    <!-- IMAGEM -->
                                    <v-img
                                      v-if="isImage(file)"
                                      :src="filePreviewUrl(file)"
                                      max-height="180"
                                      contain
                                      class="rounded"
                                    />

                                    <!-- PDF -->
                                    <iframe
                                      v-else-if="isPdf(file)"
                                      :src="filePreviewUrl(file)"
                                      class="preview-pdf"
                                    ></iframe>

                                    <!-- OUTROS -->
                                    <v-alert
                                      v-else
                                      dense
                                      outlined
                                      type="info"
                                      class="mt-2"
                                    >
                                      Não é possível visualizar este tipo de
                                      arquivo
                                      <br />
                                      <strong>{{ file.type }}</strong>
                                    </v-alert>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>

                        <v-col cols="12" class="pb-0 pt-0">
                          <v-text-field
                            v-model="documento.linkGoogleDrive"
                            label="Link (Drive Google)"
                            placeholder="Cole o link do Google Drive aqui"
                            outlined
                            dense
                            prepend-inner-icon="mdi-google-drive"
                            :rules="[rules.googleDriveUrl]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0 pt-0">
                          <v-text-field
                            v-model="documento.palavraChave"
                            label="Palavras-chave"
                            placeholder="Ex: contrato, serviços, fornecedor"
                            outlined
                            dense
                            prepend-inner-icon="mdi-key-outline"
                          ></v-text-field>
                        </v-col>
                        <v-alert
                          border="left"
                          colored-border
                          type="info"
                          dense
                          class="mt-2"
                        >
                          <div class="caption">
                            Formatos aceitos: PDF, DOC, DOCX, XLS, XLSX, JPG,
                            PNG {{ documento.departamento === 'Marketing' ? '(sem limite)' : '(máx. 20MB)' }}
                          </div>
                        </v-alert>
                      </v-col>
                      <v-col cols="6" class="d-flex justify-end"> </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card class="mb-6 card-section" outlined elevation="0">
                  <v-card-title class="section-header">
                    <v-row>
                      <v-col cols="10">
                        <v-icon color="green" class="mr-2"
                          >mdi-lock-outline</v-icon
                        >
                        Controle de Acesso
                        <v-chip
                          class="ml-2"
                          small
                          color="primary"
                          text-color="white"
                          >{{
                            gruposSelecionados.length +
                            colaboradoresSelecionados.length
                          }}</v-chip
                        >
                      </v-col>
                      <v-col cols="2" class="d-flex align-center justify-end">
                        <v-btn
                          small
                          color="primary"
                          @click="
                            permissoesDialog = true;
                            consultar_colaboradores();
                            consultar_grupo_colaboradores();
                          "
                        >
                          <v-icon color="white" left>mdi-plus</v-icon> Adicionar
                          permissão
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="py-0">
                    <v-list
                      dense
                      v-if="
                        gruposSelecionados.length > 0 ||
                        colaboradoresSelecionados.length > 0
                      "
                    >
                      <!-- Na lista de documentos vinculados -->
                      <v-list-item
                        v-for="(item, index) in gruposSelecionados"
                        :key="item.id || index"
                      >
                        <v-list-item-avatar>
                          <v-icon>mdi-account-group</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-chip small color="primary" text-color="white">
                              Grupo
                            </v-chip>
                          </v-list-item-title>
                          <v-list-item-title>
                            Nome: {{ item?.grupo?.nome }}
                          </v-list-item-title>
                          <v-list-item-title>
                            Data de Criação: {{ item?.grupo?.dataCriacao }}
                          </v-list-item-title>
                          <v-list-item-title
                            >Quantidade de Colaboradores:
                            {{ item?.colaboradores.length }}</v-list-item-title
                          >
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            text
                            small
                            @click="removerGrupoSelecionado(index)"
                          >
                            <v-icon color="red">mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                      <v-list-item
                        v-for="(item, index) in colaboradoresSelecionados"
                        :key="item.id || index"
                      >
                        <v-list-item-avatar>
                          <v-icon>mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-chip small color="secondary" text-color="white">
                              Colaborador
                            </v-chip>
                          </v-list-item-title>
                          <v-list-item-title>
                            Nome: {{ item?.nome }}
                          </v-list-item-title>
                          <v-list-item-title>
                            Empresa: {{ item?.empresa }}
                          </v-list-item-title>
                          <v-list-item-title
                            >Cargo: {{ item?.cargo }}</v-list-item-title
                          >
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            text
                            small
                            @click="removerColaboradorSelecionado(index)"
                          >
                            <v-icon color="red">mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                    <div v-else class="text-center py-4">
                      Nenhuma permissão encontrada.
                    </div>
                  </v-card-text>
                </v-card>

                <!-- Lista de documentos vinculados -->
                <v-card
                  class="mb-6 card-section"
                  outlined
                  elevation="0"
                  v-if="documentosVinculados.length > 0"
                >
                  <v-card-title class="section-header">
                    <v-icon color="green" class="mr-2">mdi-link-variant</v-icon>
                    Listagem de documentos inseridos (vinculados)
                    <v-chip
                      class="ml-2"
                      small
                      color="primary"
                      text-color="white"
                      >{{ documentosVinculados.length }}</v-chip
                    >
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="py-0">
                    <v-list dense>
                      <v-list-item
                        v-for="(doc, index) in documentosVinculados"
                        :key="index"
                      >
                        <v-list-item-avatar>
                          <v-icon>mdi-file-document-outline</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            <strong>
                              <v-icon size="16" color="yellow">
                                mdi-clock-outline
                              </v-icon>
                              Status: Pendente
                            </strong>
                          </v-list-item-title>
                          <v-list-item-title>{{
                            doc.arquivo.name
                          }}</v-list-item-title>
                          <v-list-item-subtitle>{{
                            formatFileSize(doc.arquivo.size)
                          }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            text
                            small
                            @click="removerDocumentoVinculado(index)"
                          >
                            <v-icon color="error">mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>

                <!-- Botões de Ação -->
                <v-card elevation="0">
                  <v-card-actions class="pa-4">
                    <v-btn
                      color="orange"
                      @click="abrirNovoDocumento()"
                      :disabled="!valid || !arquivo"
                      class="text-capitalize font-weight-medium mt-2"
                    >
                      <v-icon left>mdi-link-variant</v-icon>
                      Adicionar novo documento
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="black"
                      text
                      @click="resetForm"
                      :disabled="loading"
                      class="text-capitalize font-weight-medium mr-3"
                    >
                      <v-icon left>mdi-refresh</v-icon>
                      Limpar Formulário
                    </v-btn>
                    <v-btn
                      color="success"
                      @click="salvar"
                      :loading="loading"
                      :disabled="
                        (!valid || loading) && documentosVinculados.length === 0 && !documento.linkGoogleDrive
                      "
                      class="text-capitalize font-weight-medium"
                      elevation="2"
                    >
                      {{ loading ? "Salvando..." : "Salvar Documento" }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-container>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
import rh from "@/services/rh";
import permissoesService from "@/services/permissoes";
const hoje = new Date();
const proximoAno = new Date(hoje);
proximoAno.setFullYear(hoje.getFullYear() + 1);
const dataFormatada = proximoAno.toISOString().split("T")[0];

export default {
  name: "NovosArquivos",
  data() {
    return {
      valid: false,
      loading: false,
      newDoc: false,
      dataValidadeMenu: false,
      dataVencimentoMenu: false,
      showDatas: false,
      arquivo: null,
      documentosVinculados: [],
      erroDialog: false,
      mensagemErro: "",
      headersColaboradores: [
        { text: "", value: "selecionar", sortable: false },
        { text: "Empresa", value: "empresa" },
        { text: "Nome Completo", value: "nome" },
        { text: "Departamento", value: "departamento" },
        { text: "Cargo", value: "cargo" },
      ],
      headersGrupos: [
        { text: "Nome", value: "grupo.nome" },
        { text: "Colaboradores", value: "colaboradores" },
        { text: "Data de Criação", value: "grupo.dataCriacao" },
        { text: "Modelo", value: "grupo.modelo" },
      ],
      search: "",
      tipoPermissao: "",
      listaColaboradores: [],
      listaGrupos: [],
      colaboradoresSelecionados: [],
      gruposSelecionados: [],
      permissoes: [],
      permissoesDialog: false,
      documento: {
        titulo: "",
        nomeArquivo: "",
        descricao: "",
        status: "Ativo",
        tipo: "",
        palavraChave: "",
        categoria: "",
        subCategoria: "",
        departamento: "",
        empresa: "",
        identificacao: "",
        usuarioInsert: "",
        dataInsert: null,
        usuarioUpdate: "",
        dataUpdate: null,
        dataValidade: dataFormatada,
        dataVencimento: dataFormatada,
        arquivoExterno: "",
        linkGoogleDrive: "",
      },
      rules: {
        required: (v) => !!v || "Campo obrigatório",
        fileSize: (v) =>
          !v || v.size < 10000000 || "O arquivo deve ter menos de 10MB",
        fileSizeByDepartamento: (v) => {
          if (!v || v.length === 0) return true;

          if (this.documento.departamento === "Marketing") {
            return true;
          }

          const totalSize = v.reduce((acc, file) => acc + file.size, 0);

          return (
            totalSize <= 20 * 1024 * 1024 ||
            "O tamanho total dos arquivos não pode ultrapassar 20MB"
          );
        },
        googleDriveUrl: (v) => {
          if (!v) return true; // Campo opcional, só valida se preenchido
          
          // Valida se é uma URL válida
          try {
            const url = new URL(v);
            
            // Verifica se é do Google Drive
            const isGoogleDrive = 
              url.hostname === 'drive.google.com' || 
              url.hostname === 'www.drive.google.com' ||
              url.hostname.includes('drive.google.com');
            
            if (!isGoogleDrive) {
              return "Por favor, insira um link válido do Google Drive";
            }
            
            // Verifica se tem o formato correto (deve ter /file/d/ ou /folders/ ou /open)
            const validPaths = ['/file/d/', '/folders/', '/open'];
            const hasValidPath = validPaths.some(path => url.pathname.includes(path));
            
            if (!hasValidPath) {
              return "Link do Google Drive inválido. Use um link de compartilhamento válido";
            }
            
            return true;
          } catch (e) {
            return "Por favor, insira uma URL válida do Google Drive";
          }
        },
      },
      tipos: ["PDF", "Planilha", "Documento de Texto", "Imagem", "Outros"],
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
        "CEMITERIO PREVIDA SÃO MIGUEL",
      ],
      categorias: [
        "Contratos",
        "Financeiro",
        "Jurídico",
        "Políticas",
        "Procedimentos",
        "Processos",
        "Recursos Humanos",
        "Relatórios",
        "Técnico",
      ],
      categoriasMarketing: [
        "Instagram",
        "Facebook",
        "TikTok",
        "YouTube",
        "LinkedIn",
        "X (Twitter)",
        "Pinterest",
        "Google",
        "Meta Ads",
      ],

      categoriasMap: {
        Contratos: [
          "Planos",
          "Jazigos",
          "Cancelamentos",
          "Clientes",
          "Fornecedores",
          "Locação",
          "Manutenção",
          "Parceiros",
          "Prestação de Serviços",
        ],
        Relatórios: [
          "Relatório Anual",
          "Relatório de Auditoria",
          "Relatório de Desempenho",
          "Relatório de Vendas",
          "Relatório Financeiro",
          "Relatório Mensal",
        ],
        Procedimentos: [
          "Instruções de Trabalho",
          "Manual de Operação",
          "Procedimento Administrativo",
          "Procedimento de Qualidade",
          "Procedimento Operacional",
          "Procedimento de Segurança",
        ],
        Políticas: [
          "Código de Conduta",
          "Normas Internas",
          "Política de Compliance",
          "Política de Privacidade",
          "Política de RH",
          "Política de Segurança",
        ],
        Financeiro: [
          "Caixa",
          "Comprovantes",
          "Demonstrativos",
          "Extratos",
          "Impostos",
          "Notas Fiscais",
          "Orçamentos",
        ],
        "Recursos Humanos": [
          "Avaliações",
          "Benefícios",
          "Documentos Pessoais",
          "Férias",
          "Folha de Pagamento",
          "Treinamentos",
        ],
        Jurídico: [
          "Certidões",
          "Documentos Societários",
          "Licenças",
          "Pareceres",
          "Processos",
          "Procurações",
        ],
        Técnico: [
          "Certificações",
          "Especificações",
          "Laudos Técnicos",
          "Manuais Técnicos",
          "Plantas",
          "Projetos",
        ],
        Processos: ["Sorteio", "Regulação", "Apólice"],
        Instagram: [
          "Anúncio Single Image",
          "Banner do Canal",
          "Capa (Header)",
          "Capa de Evento",
          "Capa de Página",
          "Capa de Perfil",
          "Carrossel",
          "Feed (Quadrado)",
          "Feed (Retrato)",
          "Feed Post (Paisagem)",
          "Feed Post (Quadrado)",
          "Foto de Perfil",
          "Half Page",
          "Idea Pin",
          "Imagem Paisagem",
          "In-Feed Video",
          "Large Rectangle",
          "Leaderboard",
          "Logo de Empresa",
          "Medium Rectangle",
          "Mobile Leaderboard",
          "Post de Imagem",
          "Reels",
          "Responsive Display (Landscape)",
          "Responsive Display (Square)",
          "Shorts",
          "Standard Pin",
          "Stories",
          "Stories/Reels Ads",
          "Story",
          "Thumbnail de Vídeo",
          "Wide Skyscraper",
        ],
        Facebook: [
          "Anúncio Single Image",
          "Banner do Canal",
          "Capa (Header)",
          "Capa de Evento",
          "Capa de Página",
          "Capa de Perfil",
          "Carrossel",
          "Feed (Quadrado)",
          "Feed (Retrato)",
          "Feed Post (Paisagem)",
          "Feed Post (Quadrado)",
          "Foto de Perfil",
          "Half Page",
          "Idea Pin",
          "Imagem Paisagem",
          "In-Feed Video",
          "Large Rectangle",
          "Leaderboard",
          "Logo de Empresa",
          "Medium Rectangle",
          "Mobile Leaderboard",
          "Post de Imagem",
          "Reels",
          "Responsive Display (Landscape)",
          "Responsive Display (Square)",
          "Shorts",
          "Standard Pin",
          "Stories",
          "Stories/Reels Ads",
          "Story",
          "Thumbnail de Vídeo",
          "Wide Skyscraper",
        ],
        TikTok: [
          "Anúncio Single Image",
          "Banner do Canal",
          "Capa (Header)",
          "Capa de Evento",
          "Capa de Página",
          "Capa de Perfil",
          "Carrossel",
          "Feed (Quadrado)",
          "Feed (Retrato)",
          "Feed Post (Paisagem)",
          "Feed Post (Quadrado)",
          "Foto de Perfil",
          "Half Page",
          "Idea Pin",
          "Imagem Paisagem",
          "In-Feed Video",
          "Large Rectangle",
          "Leaderboard",
          "Logo de Empresa",
          "Medium Rectangle",
          "Mobile Leaderboard",
          "Post de Imagem",
          "Reels",
          "Responsive Display (Landscape)",
          "Responsive Display (Square)",
          "Shorts",
          "Standard Pin",
          "Stories",
          "Stories/Reels Ads",
          "Story",
          "Thumbnail de Vídeo",
          "Wide Skyscraper",
        ],
        YouTube: [
          "Anúncio Single Image",
          "Banner do Canal",
          "Capa (Header)",
          "Capa de Evento",
          "Capa de Página",
          "Capa de Perfil",
          "Carrossel",
          "Feed (Quadrado)",
          "Feed (Retrato)",
          "Feed Post (Paisagem)",
          "Feed Post (Quadrado)",
          "Foto de Perfil",
          "Half Page",
          "Idea Pin",
          "Imagem Paisagem",
          "In-Feed Video",
          "Large Rectangle",
          "Leaderboard",
          "Logo de Empresa",
          "Medium Rectangle",
          "Mobile Leaderboard",
          "Post de Imagem",
          "Reels",
          "Responsive Display (Landscape)",
          "Responsive Display (Square)",
          "Shorts",
          "Standard Pin",
          "Stories",
          "Stories/Reels Ads",
          "Story",
          "Thumbnail de Vídeo",
          "Wide Skyscraper",
        ],
        LinkedIn: [
          "Anúncio Single Image",
          "Banner do Canal",
          "Capa (Header)",
          "Capa de Evento",
          "Capa de Página",
          "Capa de Perfil",
          "Carrossel",
          "Feed (Quadrado)",
          "Feed (Retrato)",
          "Feed Post (Paisagem)",
          "Feed Post (Quadrado)",
          "Foto de Perfil",
          "Half Page",
          "Idea Pin",
          "Imagem Paisagem",
          "In-Feed Video",
          "Large Rectangle",
          "Leaderboard",
          "Logo de Empresa",
          "Medium Rectangle",
          "Mobile Leaderboard",
          "Post de Imagem",
          "Reels",
          "Responsive Display (Landscape)",
          "Responsive Display (Square)",
          "Shorts",
          "Standard Pin",
          "Stories",
          "Stories/Reels Ads",
          "Story",
          "Thumbnail de Vídeo",
          "Wide Skyscraper",
        ],
        "X (Twitter)": [
          "Anúncio Single Image",
          "Banner do Canal",
          "Capa (Header)",
          "Capa de Evento",
          "Capa de Página",
          "Capa de Perfil",
          "Carrossel",
          "Feed (Quadrado)",
          "Feed (Retrato)",
          "Feed Post (Paisagem)",
          "Feed Post (Quadrado)",
          "Foto de Perfil",
          "Half Page",
          "Idea Pin",
          "Imagem Paisagem",
          "In-Feed Video",
          "Large Rectangle",
          "Leaderboard",
          "Logo de Empresa",
          "Medium Rectangle",
          "Mobile Leaderboard",
          "Post de Imagem",
          "Reels",
          "Responsive Display (Landscape)",
          "Responsive Display (Square)",
          "Shorts",
          "Standard Pin",
          "Stories",
          "Stories/Reels Ads",
          "Story",
          "Thumbnail de Vídeo",
          "Wide Skyscraper",
        ],
        Pinterest: [
          "Anúncio Single Image",
          "Banner do Canal",
          "Capa (Header)",
          "Capa de Evento",
          "Capa de Página",
          "Capa de Perfil",
          "Carrossel",
          "Feed (Quadrado)",
          "Feed (Retrato)",
          "Feed Post (Paisagem)",
          "Feed Post (Quadrado)",
          "Foto de Perfil",
          "Half Page",
          "Idea Pin",
          "Imagem Paisagem",
          "In-Feed Video",
          "Large Rectangle",
          "Leaderboard",
          "Logo de Empresa",
          "Medium Rectangle",
          "Mobile Leaderboard",
          "Post de Imagem",
          "Reels",
          "Responsive Display (Landscape)",
          "Responsive Display (Square)",
          "Shorts",
          "Standard Pin",
          "Stories",
          "Stories/Reels Ads",
          "Story",
          "Thumbnail de Vídeo",
          "Wide Skyscraper",
        ],
        Google: [
          "Anúncio Single Image",
          "Banner do Canal",
          "Capa (Header)",
          "Capa de Evento",
          "Capa de Página",
          "Capa de Perfil",
          "Carrossel",
          "Feed (Quadrado)",
          "Feed (Retrato)",
          "Feed Post (Paisagem)",
          "Feed Post (Quadrado)",
          "Foto de Perfil",
          "Half Page",
          "Idea Pin",
          "Imagem Paisagem",
          "In-Feed Video",
          "Large Rectangle",
          "Leaderboard",
          "Logo de Empresa",
          "Medium Rectangle",
          "Mobile Leaderboard",
          "Post de Imagem",
          "Reels",
          "Responsive Display (Landscape)",
          "Responsive Display (Square)",
          "Shorts",
          "Standard Pin",
          "Stories",
          "Stories/Reels Ads",
          "Story",
          "Thumbnail de Vídeo",
          "Wide Skyscraper",
        ],
        "Meta Ads": [
          "Anúncio Single Image",
          "Banner do Canal",
          "Capa (Header)",
          "Capa de Evento",
          "Capa de Página",
          "Capa de Perfil",
          "Carrossel",
          "Feed (Quadrado)",
          "Feed (Retrato)",
          "Feed Post (Paisagem)",
          "Feed Post (Quadrado)",
          "Foto de Perfil",
          "Half Page",
          "Idea Pin",
          "Imagem Paisagem",
          "In-Feed Video",
          "Large Rectangle",
          "Leaderboard",
          "Logo de Empresa",
          "Medium Rectangle",
          "Mobile Leaderboard",
          "Post de Imagem",
          "Reels",
          "Responsive Display (Landscape)",
          "Responsive Display (Square)",
          "Shorts",
          "Standard Pin",
          "Stories",
          "Stories/Reels Ads",
          "Story",
          "Thumbnail de Vídeo",
          "Wide Skyscraper",
        ],
      },

      departamentos: [
        "Administrativo",
        "Comercial",
        "Call Center",
        "Financeiro",
        "Faturamento e Contratos",
        "RH",
        "Operacional",
        "Jurídico",
        "TIC",
        "Compras",
        "Marketing",
        "Diretoria",
        "Seguros",
        "SAC",
      ],
      usuario: "",
    };
  },
  mounted() {
    const usuario = JSON.parse(sessionStorage.getItem("user")) || "";
    this.usuario = usuario.nome;
    this.$nextTick(() => {
      this.autoSelectEmpresa();
    });
  },
  computed: {
    idOrigem() {
      return this.$route.query.idOrigem || null;
    },
    arquivosSelecionados() {
      return Array.isArray(this.arquivo) ? this.arquivo : [];
    },

    filteredEmpresas() {
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
    categoriasDisponiveis() {
      if (this.documento.departamento === "Marketing") {
        return this.categoriasMarketing;
      }
      return this.categorias;
    },
    dataValidadeFormatted() {
      return this.documento.dataValidade
        ? this.formatDate(this.documento.dataValidade)
        : "";
    },
    dataVencimentoFormatted() {
      return this.documento.dataVencimento
        ? this.formatDate(this.documento.dataVencimento)
        : "";
    },
    subcategoriasDisponiveis() {
      return this.documento.categoria
        ? this.categoriasMap[this.documento.categoria] || []
        : [];
    },
    isContratoCategoria() {
      return this.documento.categoria === "Contratos";
    },
    consultarLabelCampoChave() {
      switch (this.documento.categoria) {
        case "Contratos":
          return "Número do Contrato";
        case "Relatórios":
          return "Número do Relatório";
        case "Procedimentos":
          return "Número do Procedimento";
        case "Políticas":
          return "Número da Política";
        case "Financeiro":
          return "Número do Documento";
        case "Recursos Humanos":
          return "Número do Documento";
        case "Jurídico":
          return "Número do Documento";
        case "Técnico":
          return "Número do Documento";
        default:
          return "Número do Documento";
      }
    },
  },
  watch: {
    "documento.categoria"(newCategoria) {
      // Limpa a subcategoria quando a categoria muda
      this.documento.subCategoria = "";
    },
    "documento.departamento"(newDepartamento) {
      // Limpa a categoria e subcategoria quando o departamento muda
      this.documento.categoria = "";
      this.documento.subCategoria = "";
    },
  },
  methods: {
    filePreviewUrl(file) {
      return URL.createObjectURL(file);
    },

    isImage(file) {
      return file.type.startsWith("image/");
    },

    isPdf(file) {
      return file.type === "application/pdf";
    },

    formatSize(bytes) {
      if (!bytes) return "0 KB";
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
    },
    // Se houver apenas uma empresa, seleciona automaticamente
    autoSelectEmpresa() {
      const empresasPermitidas = this.empresas.filter((empresa) =>
        this.hasPermission(empresa),
      );

      if (empresasPermitidas.length === 1) {
        this.documento.empresa = empresasPermitidas[0];
      }
    },
    hasPermission(empresa) {
      this.user = JSON.parse(sessionStorage.getItem("user"));

      if (this.user.roles.includes("ROLE_ADMIN")) {
        return true;
      } else if (empresa === "Todas") {
        return true;
      } else {
        const requiredRoles = empresa
          .split(",")
          .map(
            (name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_"),
          );

        const hasAnyRequiredRole = requiredRoles.some((role) =>
          this.user.roles.includes(role),
        );
        return hasAnyRequiredRole;
      }
    },
    consultar_colaboradores() {
      rh.lista_colaboradores_ativos()
        .then((response) => {
          this.listaColaboradores = response.data;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {});
    },
    consultar_grupo_colaboradores() {
      rh.lista_grupos_colaboradorores("Arquivos", true).then((response) => {
        this.listaGrupos = response.data;
      });
    },
    abrirNovoDocumento() {
      if (this.documentosVinculados.length === 0) {
        this.newDoc = true;
        return;
      } else {
        this.vincularDocumento();
        this.$nextTick(() => {
          const el = document.getElementById("informacoes_basicas");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
        return;
      }
    },
    formatDate(date) {
      if (!date) return "";
      // Verifica se a data está no formato brasileiro (DD/MM/YYYY)
      if (date.includes("/")) {
        const [day, month, year] = date.split("/");
        return `${year}-${month}-${day}`;
      }
      // Se estiver no formato ISO (YYYY-MM-DD)
      else if (date.includes("-")) {
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      }
      return date;
    },
    formatFileSize(size) {
      if (!size) return "";
      const kb = size / 1024;
      if (kb < 1024) {
        return `${kb.toFixed(2)} KB`;
      }
      const mb = kb / 1024;
      return `${mb.toFixed(2)} MB`;
    },
    vincularDocumento() {
      if (!this.arquivo || this.arquivo.length === 0) {
        this.mensagemErro = "Por favor, selecione um arquivo para vincular.";
        this.erroDialog = true;
        return;
      }

      // Verifica se é um array de arquivos ou um único arquivo
      if (Array.isArray(this.arquivo)) {
        // Processa múltiplos arquivos
        for (const file of this.arquivo) {
          const documentoCopia = JSON.parse(JSON.stringify(this.documento));
          documentoCopia.tipo = file.type;
          documentoCopia.nomeArquivo = file.name;

          this.documentosVinculados.push({
            documento: documentoCopia,
            arquivo: file,
          });
        }
      } else {
        // Processa um único arquivo (compatibilidade)
        const documentoCopia = JSON.parse(JSON.stringify(this.documento));
        documentoCopia.tipo = this.arquivo.type;
        documentoCopia.nomeArquivo = this.arquivo.name;

        this.documentosVinculados.push({
          documento: documentoCopia,
          arquivo: this.arquivo,
        });
      }

      this.arquivo = null;
      this.documento.titulo = "";
      this.documento.descricao = "";
      this.documento.palavraChave = "";
      this.documento.linkGoogleDrive = "";
      this.documento.identificacao = "";
      this.documento.nomeArquivo = "";

      this.$nextTick(() => {
        const el = document.getElementById("informacoes_basicas");
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    removerDocumentoVinculado(index) {
      this.documentosVinculados.splice(index, 1);
    },
    removerGrupoSelecionado(index) {
      this.gruposSelecionados.splice(index, 1);
    },
    removerColaboradorSelecionado(index) {
      this.colaboradoresSelecionados.splice(index, 1);
    },
    async salvar() {
      // Verifica se tem pelo menos um documento (principal ou vinculado) ou link do Google Drive
      if (!this.arquivo && this.documentosVinculados.length === 0 && !this.documento.linkGoogleDrive) {
        this.mensagemErro = "Por favor, selecione pelo menos um arquivo para salvar ou preencha o link do Google Drive.";
        this.erroDialog = true;
        return;
      }

      // Valida o link do Google Drive se estiver preenchido
      if (this.documento.linkGoogleDrive) {
        const validationResult = this.rules.googleDriveUrl(this.documento.linkGoogleDrive);
        if (validationResult !== true) {
          this.mensagemErro = validationResult;
          this.erroDialog = true;
          return;
        }
      }

      this.loading = true;
      this.documento.usuarioInsert = this.usuario;
      this.documento.usuarioUpdate = this.usuario;

      if (!this.showDatas) {
        this.documento.dataValidade = null;
        this.documento.dataVencimento = null;
      }
      try {
        // Lista de documentos a serem enviados
        const documentosParaEnviar = [];

        // Adiciona os documentos vinculados à lista
        for (const item of this.documentosVinculados) {
          const docCopy = { ...item.documento };
          // Converte o arquivo para base64 e o inclui no objeto do documento
          await this.fileToBase64(item.arquivo).then((base64) => {
            docCopy.arquivoBase64 = base64;
          });
          documentosParaEnviar.push(docCopy);
        }

        // Adiciona o documento principal à lista se tiver um arquivo selecionado ou link do Google Drive
        if (this.valid && (this.arquivo || this.documento.linkGoogleDrive)) {
          if (this.arquivo) {
            // Verifica se é um array de arquivos ou um único arquivo
            if (Array.isArray(this.arquivo)) {
              // Processa múltiplos arquivos
              for (const file of this.arquivo) {
                const docPrincipal = JSON.parse(JSON.stringify(this.documento));
                docPrincipal.tipo = file.type;
                docPrincipal.nomeArquivo = file.name;
                await this.fileToBase64(file).then((base64) => {
                  docPrincipal.arquivoBase64 = base64;
                });
                documentosParaEnviar.push(docPrincipal);
              }
            } else {
              // Processa um único arquivo (compatibilidade)
              const docPrincipal = JSON.parse(JSON.stringify(this.documento));
              docPrincipal.tipo = this.arquivo.type;
              docPrincipal.nomeArquivo = this.arquivo.name;
              await this.fileToBase64(this.arquivo).then((base64) => {
                docPrincipal.arquivoBase64 = base64;
              });
              documentosParaEnviar.push(docPrincipal);
            }
          } else if (this.documento.linkGoogleDrive) {
            // Adiciona documento apenas com link do Google Drive (sem arquivo)
            const docPrincipal = JSON.parse(JSON.stringify(this.documento));
            documentosParaEnviar.push(docPrincipal);
          }
        }

        // Faz uma única requisição com a lista de documentos diretamente
        const response = await http.post(
          "/ged/arquivos/" + (this.idOrigem || ""),
          documentosParaEnviar,
          {
            headers: authHeader(),
          },
        );

        // Salvar permissões para os arquivos criados
        if (response.data && Array.isArray(response.data)) {
          // Para cada arquivo salvo
          for (const arquivo of response.data) {
            // Salvar permissões de grupos
            for (const grupo of this.gruposSelecionados) {
              try {
                await permissoesService.cadastrar_permissao({
                  arquivoId: arquivo.id,
                  idPermissao: grupo.grupo.id,
                  tipoPermissao: "GRUPO",
                });
              } catch (error) {
                console.error("Erro ao salvar permissão de grupo:", error);
              }
            }

            // Salvar permissões de colaboradores
            for (const colaborador of this.colaboradoresSelecionados) {
              try {
                await permissoesService.cadastrar_permissao({
                  arquivoId: arquivo.id,
                  idPermissao: colaborador.id,
                  tipoPermissao: "COLABORADOR",
                });
              } catch (error) {
                console.error(
                  "Erro ao salvar permissão de colaborador:",
                  error,
                );
              }
            }
          }
        }

        this.voltar();
      } catch (error) {
        console.error("Erro ao salvar documento:", error);
        
        // Extrai a mensagem de erro da resposta
        let mensagem = "Erro ao salvar documento. Tente novamente.";
        
        if (error.response && error.response.data) {
          // Tenta extrair a mensagem de erro do response
          if (error.response.data.error) {
            mensagem = error.response.data.error;
          } else if (error.response.data.message) {
            mensagem = error.response.data.message;
          } else if (typeof error.response.data === 'string') {
            mensagem = error.response.data;
          }
        } else if (error.message) {
          mensagem = error.message;
        }
        
        this.mensagemErro = mensagem;
        this.erroDialog = true;
      } finally {
        this.loading = false;
      }
    },

    // Função para converter arquivo para base64
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        if (!file) {
          resolve(null);
          return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Remove o prefixo (ex: "data:application/pdf;base64,") para obter apenas o base64
          const base64String = reader.result.split(",")[1];
          resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
      });
    },
    voltar() {
      if (this.idOrigem) {
        this.$router.push(`/consultaArquivo/${this.idOrigem}`);
      } else {
        this.$router.push("/gestaoArquivos");
      }
      this.resetForm();
    },
    resetForm() {
      this.$refs.form.reset();
      this.arquivo = null;
      this.documentosVinculados = [];
      this.idOrigem = null;
      this.documento = {
        titulo: "",
        descricao: "",
        status: "Ativo",
        nomeArquivo: "",
        tipo: "",
        palavraChave: "",
        categoria: "",
        subCategoria: "",
        departamento: "",
        empresa: "",
        identificacao: "",
        usuarioInsert: "",
        dataInsert: null,
        usuarioUpdate: "",
        dataUpdate: null,
        dataValidade: null,
        dataVencimento: null,
        arquivoExterno: "",
        linkGoogleDrive: "",
      };
    },
  },
};
</script>

<style scoped>
.card-section {
  border-radius: 12px;
}

.section-header {
  padding: 16px 20px;
  border-radius: 12px 12px 0 0;
}

.v-btn {
  text-transform: none !important;
  letter-spacing: 0.5px;
  font-weight: 500 !important;
  border-radius: 8px;
}

.v-text-field--outlined >>> .v-input__control > .v-input__slot {
  border-radius: 8px;
}

.v-select--outlined >>> .v-input__control > .v-input__slot {
  border-radius: 8px;
}

.v-textarea--outlined >>> .v-input__control > .v-input__slot {
  border-radius: 8px;
}

.v-file-input >>> .v-input__control > .v-input__slot {
  border-radius: 8px;
}

.v-alert {
  border-radius: 8px;
}
.expansion-panel {
  border-radius: 8px;
  border: 1px solid rgb(224 224 224);
}
.preview-pdf {
  width: 100%;
  height: 380px;
  border: none;
  border-radius: 6px;
}
</style>
